<!-- 表1填写 -->

<template>
  <div class="tabCage table2">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 1-2：资质情况表 ———— 音像制品出版许可证</span>
      <span v-else>表 1-2：资质情况表 ———— 电子出版物出版许可证</span>
      <el-button type="primary" size="small" @click="getcode202HistoryData">导入历史数据</el-button>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="headBar">
      <span>出版许可证信息（请按照出版许可证上的信息填写）</span>
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">出版许可证号：</td>
            <td class="edInpBig">
              <el-form-item prop="xkzNum" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.xkzNum"
                  size="small"
                  placeholder="请输入出版许可证号"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInpBig">
              <el-form-item prop="orgName" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.orgName"
                  size="small"
                  placeholder="请输入出版许可证号上“单位名称”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">单位地址：</td>
            <td class="edInpBig">
              <el-form-item prop="orgAddr" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.orgAddr"
                  size="small"
                  placeholder="请输入出版许可证号上“单位地址”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版者码：</td>
            <td class="edInp areaTime">
              <el-form-item prop="cbzMa" :inline-message="true">
                <el-input v-model="params.cbzMa" size="small" placeholder="请输入出版许可证号上“出版者码”项"></el-input>
              </el-form-item>
              <span class="tips">注：若没有，请填写“无”</span>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-form-item prop="fddbr" :inline-message="true">
                <el-input
                  v-model="params.fddbr"
                  size="small"
                  placeholder="请输入出版许可证号上“法定代表人”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">有效日期：</td>
            <td class="edInp areaTime">
              <el-form-item prop="yxStartDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(1)"
                  v-model="params.yxStartDate"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
              <span class="midSpan">至</span>
              <el-form-item prop="yxEndDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(2)"
                  v-model="params.yxEndDate"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版范围：</td>
            <td class="edInpTextArea">
              <el-form-item prop="businessScope" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="8"
                  v-model="params.businessScope"
                  size="small"
                  placeholder="请输入出版许可证号上“出版范围”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">其他主要业务：</td>
            <td class="edInpTextArea">
              <el-form-item prop="otherScope" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="params.otherScope"
                  size="small"
                  placeholder="请填写除音像电子出版业务外本单位或本部门经营的其他主要业务"></el-input>
              </el-form-item>
              <span class="tips">注：若没有，请填写“无”</span>
            </td>
          </tr>

          <tr>
            <td class="edName">出版单位设立获批时间：</td>
            <td class="edInp areaTime">
              <el-form-item prop="approvalTime" :inline-message="true">
                <el-date-picker
                  v-model="params.approvalTime"
                  align="right"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <span class="tips">注：请填写出版单位最早获得批复的发文时间</span>
            </td>
          </tr>
          <tr>
            <td class="edName">上传发文文件：</td>
            <td class="edInp">
              <UpbtnPdf class="upBtn" :fileID="publishFileId" @upFileId="fileTdSetPublishFileId" />
              <div class="tips" style="margin-top: 5px; line-height: 20px">
                <span style="color: red">注：</span
                >上传最早获得国家出版行政管理部门批复的发文文件，如果无法上传，请上传加盖社章的情况说明文件。
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传文件格式为PDF，文件大小不超过10M
              </div>
              <!-- <div class="tips" style="margin-top:-24px;"></div> -->
            </td>
          </tr>
          <tr>
            <td class="edName">需要说明的其他情况：</td>
            <td class="edInpTextArea">
              <!-- <el-form-item prop="otherSituation" :inline-message="true">
                                                                                                  			 	  	  	  	      <el-input type="textarea" :rows="3" v-model="params.otherSituation" size="small" placeholder="请输入需要说明的其他情况"></el-input>
                                                                                                  			 	  	  	  	  </el-form-item> -->
              <el-input
                type="textarea"
                :rows="2"
                v-model="params.otherSituation"
                size="small"
                placeholder="请输入需要说明的其他情况"></el-input>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName uploadLine">上传出版许可证：</td>
            <td class="edInp">
              <Upbtn @upFileId="fileTdSet" :ableSure="imgId" :limit="5" />

              <div class="tips">
                注：上传文件格式为JPGE/PNG，文件大小不超过10M
              </div>
                                                                                          </td>
                                                                                        </tr> -->
          <tr>
            <td class="edName uploadLine">上传出版许可证：</td>
            <td class="edInp">
              <!-- <span style="color:red;">注：每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M</span> -->
              <span style="color: red; line-height: 24px">
                注：按照五张图片的上传要求，逐一上传出版许可证相应页面，每张图片必须提供许可证的某一页，不能一张图片中包含多页内容。
                <br />
                图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。
                <br />
                每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M。
              </span>
              <br />
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId1"
                  @upFileId="fileTdSet1"
                  :btnProps="{ colId: 'xkzFileId1' }" />
                <div class="imgblocktag">出版许可证正本</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId2"
                  @upFileId="fileTdSet1"
                  :btnProps="{ colId: 'xkzFileId2' }" />
                <div class="imgblocktag">出版许可证副本盖章页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId3"
                  @upFileId="fileTdSet1"
                  :btnProps="{ colId: 'xkzFileId3' }" />
                <div class="imgblocktag">出版许可证副本单位信息页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId4"
                  @upFileId="fileTdSet1"
                  :btnProps="{ colId: 'xkzFileId4' }" />
                <div class="imgblocktag">出版许可证副本年度核验记录页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId5"
                  @upFileId="fileTdSet1"
                  :btnProps="{ colId: 'xkzFileId5' }" />
                <div class="imgblocktag">出版许可证副本变更记录页</div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="headBar">
        <span>主办及主管单位信息</span>
      </div>

      <div class="editArea">
        <table>
          <tr>
            <td class="edName">主办单位：</td>
            <td class="edInp">
              <el-form-item prop="hostName" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.hostName"
                  size="small"
                  placeholder="请输入主办单位名称"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">单位性质：</td>
            <td class="edInp edSelect">
              <el-radio-group v-model="params.hostType">
                <el-radio :label="'1'">中央</el-radio>
                <el-radio :label="'2'">地方</el-radio>
              </el-radio-group>
              <!-- <el-form-item prop="hostType" width="100px">
                <el-radio v-model="params.hostType" label="1">中央</el-radio>
                <el-radio v-model="params.hostType" label="2">地方</el-radio>
              </el-form-item> -->
            </td>
          </tr>
          <tr>
            <td class="edName"></td>
            <td class="edInp edSelect">
              <el-form-item prop="hostCategory" width="200px">
                <el-select v-model="params.hostCategory" width="200px" size="small" placeholder="请选择主办单位性质">
                  <el-option v-for="item in cats" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="params.hostCategory == '5'" prop="hostOtherCategory" :inline-message="true">
                <el-input
                  v-model="params.hostOtherCategory"
                  size="small"
                  placeholder="需要填写具体主办单位性质"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-form-item prop="hostAddr" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.hostAddr"
                  size="small"
                  placeholder="请输入主办单位地址"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-form-item prop="hostPostalcode" :inline-message="true">
                <el-input v-model="params.hostPostalcode" size="small" placeholder="请输入主办单位邮政编码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-form-item prop="hostLinkman" :inline-message="true">
                <el-input v-model="params.hostLinkman" size="small" placeholder="请输入主办单位联系人"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-form-item prop="hostTel" :inline-message="true">
                <el-input v-model="params.hostTel" size="small" placeholder="请输入主办单位联系人座机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="hostPhone" :inline-message="true">
                <el-input v-model="params.hostPhone" size="small" placeholder="请输入主办单位联系人手机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">主管单位：</td>
            <td class="edInp">
              <el-form-item prop="chargeName" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.chargeName"
                  size="small"
                  placeholder="请输入主管单位名称"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">单位性质：</td>
            <td class="edInp edSelect">
              <el-radio-group v-model="params.chargeType">
                <el-radio :label="'1'">中央</el-radio>
                <el-radio :label="'2'">地方</el-radio>
              </el-radio-group>
              <!-- <el-form-item prop="chargeType" width="100px">
                <el-radio v-model="params.chargeType" label="1">中央</el-radio>
                <el-radio v-model="params.chargeType" label="2">地方</el-radio>
              </el-form-item> -->
            </td>
          </tr>
          <tr>
            <td class="edName"></td>
            <td class="edInp edSelect">
              <el-form-item prop="chargeCategory" width="200px">
                <el-select v-model="params.chargeCategory" width="200px" size="small" placeholder="请选择主管单位性质">
                  <el-option v-for="item in cats" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="params.chargeCategory == '5'" prop="chargeOtherCategory" :inline-message="true">
                <el-input
                  v-model="params.chargeOtherCategory"
                  size="small"
                  placeholder="需要填写具体主管单位性质"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-form-item prop="chargeAddr" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.chargeAddr"
                  size="small"
                  placeholder="请输入主管单位地址"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-form-item prop="chargePostalcode" :inline-message="true">
                <el-input
                  v-model="params.chargePostalcode"
                  size="small"
                  placeholder="请输入主管单位邮政编码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-form-item prop="chargeLinkman" :inline-message="true">
                <el-input v-model="params.chargeLinkman" size="small" placeholder="请输入主管单位联系人"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-form-item prop="chargeTel" :inline-message="true">
                <el-input v-model="params.chargeTel" size="small" placeholder="请输入主管单位联系人座机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="chargePhone" :inline-message="true">
                <el-input
                  v-model="params.chargePhone"
                  size="small"
                  placeholder="请输入主管单位联系人手机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt2";
import { mebUpdate, tabRead2, code202HistoryData } from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
// import Upbtn from "@/views/components/upload/uploadCards"
import Upbtn from "@/views/components/upload/uploadSingle";
import UpbtnPdf from "@/views/components/uploadPdf";
// import Upbtn from '@/views/components/uploadCards';
export default {
  components: {
    Upbtn,
    UpbtnPdf,
  },
  data() {
    return {
      urls1: "",
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      imgId: "",
      pressType: "",
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,

      publishFileId: "",
      xkzFileId1: "",
      xkzFileId2: "",
      xkzFileId3: "",
      xkzFileId4: "",
      xkzFileId5: "",
      xkzFileId6: "",

      cats: [
        { code: "1", name: "行政机关" },
        { code: "2", name: "事业单位" },
        { code: "3", name: "企业法人" },
        { code: "4", name: "社团法人" },
        { code: "5", name: "其他" },
      ],
    };
  },

  methods: {
    // zym.发文文件
    fileTdSetPublishFileId: function (id) {
      this.params.publishFileId = id;
      this.publishFileId = id;
    },
    // zym.废弃(原来一个许可证的时候使用)
    fileTdSet: function (id) {
      this.params.xkzFileId = id;
    },
    fileTdSet1: function (dat, btnProps) {
      // console.log("dat=", dat);
      console.log("btnProps=", JSON.stringify(btnProps));

      let colId = btnProps.colId;
      this.params[colId] = dat;

      this[colId] = dat;
    },
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          if (!this.declare.personnel) {
            this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error("申报人手机号格式错误")
          //   return
          // }
          if (!this.declare.contact) {
            this.$message.error("申报人联系方式必填");
            return;
          }
          mebUpdate({
            // pqualification: this.params,
            data: this.params,
            organizationPersonnel: this.declare,
            // 身份验证要用
            publishMaterialId: this.params.publishMaterialId,
          })
            .then((response) => {
              console.log("response=", JSON.stringify(response));
              let tipCode = response.payload.pqualification.code;
              let tipMessage = response.payload.pqualification.message;

              this.submiting = false;
              if (tipCode == -1) {
                this.$message.error(`保存错误: ${tipMessage}`);
              } else {
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
                // this.editAfter()

                this.goBack();
              }
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function () {
      console.log("this.$route.query.mtId=", this.$route.query.mtId);
      tabRead2({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        // console.log('response=',JSON.stringify(response));
        this.params = response.pqualification;

        this.publishFileId = response.pqualification.publishFileId;
        this.xkzFileId1 = response.pqualification.xkzFileId1;
        this.xkzFileId2 = response.pqualification.xkzFileId2;
        this.xkzFileId3 = response.pqualification.xkzFileId3;
        this.xkzFileId4 = response.pqualification.xkzFileId4;
        this.xkzFileId5 = response.pqualification.xkzFileId5;
        this.xkzFileId6 = response.pqualification.xkzFileId6;

        // console.log('xkzFileId1=',that.xkzFileId1);

        // this.imgId = response.pqualification.xkzFileId
        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    editAfter: function () {
      if (this.params.xkzFileId != this.imgId) {
        // detFile({
        //   id: this.imgId
        // }).then(response => {}).catch(error => {})
      }
    },

    changeHandle: function (code) {
      let newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.yxStartDate).getTime() > newDate) {
          this.params.yxStartDate = "";
          this.$message.error("有效开始日期不能大于当前日期！");
        }
      }
    },

    goBack: function () {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode202HistoryData: function () {
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      code202HistoryData({
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          loading.close();
          // this.params = response.pqualification
          delete response.pqualification.id;
          // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
          that.params = { ...that.params, ...response.pqualification, publishMaterialId: that.$route.query.mtId };
          // zym.删除申报时间
          delete that.params.updatedAt;

          // that.publishFileId = response.pqualification.publishFileId
          // that.xkzFileId1 = response.pqualification.xkzFileId1
          // that.xkzFileId2 = response.pqualification.xkzFileId2
          // that.xkzFileId3 = response.pqualification.xkzFileId3
          // that.xkzFileId4 = response.pqualification.xkzFileId4
          // that.xkzFileId5 = response.pqualification.xkzFileId5
          // that.xkzFileId6 = response.pqualification.xkzFileId6

          // console.log('xkzFileId1=',that.xkzFileId1);

          // console.log("response.pOrganizationPersonnel=", response.pOrganizationPersonnel);
          // that.declare.contact = response.pOrganizationPersonnel.contact;
          // that.declare.personnel = response.pOrganizationPersonnel.personnel;
          // that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        })
        .catch((error) => {
          that.submiting = false;
        });
    },
  },
  created: function () {
    this.pressType = this.$route.query.pressType;
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table2 {
  .tabTtl {
    .el-button {
      float: right;
    }
  }

  margin-top: 0;

  .areaTime .el-form-item {
    display: inline-block;
    vertical-align: middle;
  }

  .areaTime .midSpan {
    margin: 0px 6px;
  }

  .areaTime .tips {
    margin-left: 12px;
  }

  .el-textarea {
    vertical-align: middle;
  }

  .upBtn {
    display: inline-block;
  }

  .edName {
    width: 180px !important;
  }

  .edSelect .el-form-item {
    display: inline-block;
  }
}

.table2 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table2 .numLine {
  padding-bottom: 15px;
}

.table2 .numInp {
  display: inline-block;
}

.table2 .numInp .inpName {
  display: inline-block;
  width: 150px;
  text-align: right;
}

.table2 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table2 .numInp .inpText input {
  border-radius: 0;
}

.el-date-editor {
  border-radius: 0;
}

.table2 .el-textarea {
  width: 350px;
}
</style>



// WEBPACK FOOTER //
// table2.vue?7f833015